import { ChangeEvent, useRef } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { TAny } from 'types';

export interface IUploadVideoProps {
  onChange: (file: string) => void;
  isDisabledButton: boolean;
}

const UploadVideo = ({ onChange, isDisabledButton }: IUploadVideoProps) => {
  const inputRef = useRef<TAny>(null);

  const onChangeVideo = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      const _sizeValidation = sizeValidation(files[0]);
      onChange(_sizeValidation ? URL.createObjectURL(files[0]) : '');
      if (!_sizeValidation) {
        inputRef.current.value = '';
      }
    }
  };

  const sizeValidation = (file: File) => {
    if (!file) {
      return false;
    }

    const fileSize = Math.round(file.size / 1024);

    if (fileSize <= 10 * 1024) {
      return true;
    }

    return false;
  };

  return (
    <Box sx={{ textAlign: 'center', pt: 8, pb: 6 }}>
      <Button
        variant="contained"
        disabled={isDisabledButton}
        startIcon={<FileUploadOutlinedIcon />}
        component="label"
        size="large"
        sx={{ padding: 1.5, minWidth: '270px' }}
        htmlFor="videofile">
        Upload Video
        <input
          ref={inputRef}
          hidden
          accept="video/*"
          id="videofile"
          onChange={onChangeVideo}
          name="video"
          type="file"
        />
      </Button>
    </Box>
  );
};

export default UploadVideo;
